import { useTranslate } from "@tolgee/react";
import React, { Suspense } from "react";
import { usePageInit } from "src/common/hooks";
import { Loading } from "src/components";

const DocsandLinks = React.lazy(() => import("./DocsandLinks"));

function DocsandLinksWidget(props) {
  const { t } = useTranslate();
  usePageInit(
    t({
      key: "docsAndLinks.pageTitle",
      defaultValue: "Smart Portal - Docs and Links",
    }),
  );
  return (
    <Suspense
      fallback={
        <Loading
          addContainer
          active
          loadingText={t({
            key: "docsAndLinks.loading.docsAndLinks",
            defaultValue: "Loading Docs and Links",
          })}
        />
      }
    >
      <DocsandLinks {...props} />
    </Suspense>
  );
}

export default DocsandLinksWidget;
